import React from "react";
import styled from "styled-components";
import Select, { SingleValue, ActionMeta } from "react-select";
import { MdExpandMore } from "react-icons/md";

interface OptionType {
  value: string;
  label: string;
}

interface NotaryOwnerProps {
  value: OptionType;
  onChange: (
    newValue: SingleValue<OptionType>,
    actionMeta: ActionMeta<OptionType>
  ) => void;
  options: OptionType[];
  styles?: any;
  isSearchable?: boolean;
}

const getCustomStyles = (styles: any) => ({
  control: (provided: any) => ({
    ...provided,
    backgroundColor: "white",
    color: "black",
    borderRadius: "6px",
    width: "100%",
    border: "1px solid black",
    boxShadow: "none",
    minWidth: "170px",
    minHeight: "31px",
    cursor: "pointer",
    "&:hover": {
      borderColor: "black",
    },
    ...styles?.control, // Apply custom control styles if provided
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: "black",
    borderColor: "black",
    ...styles?.singleValue, // Apply custom singleValue styles if provided
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#D3D3D3"
      : state.isFocused
        ? "#f5f5f5"
        : "white",
    color: "black",
    cursor: "pointer",
    fontSize: styles?.option?.fontSize || "14px", // Custom font size if provided, default to 14px
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    padding: "4px",
    color: "black",
    ...styles?.dropdownIndicator, // Apply custom dropdownIndicator styles if provided
  }),
  indicatorSeparator: () => ({
    display: "none",
    ...styles?.indicatorSeparator, // Apply custom indicatorSeparator styles if provided
  }),
  indicatorContainer: (base: any) => ({
    ...base,
    position: "absolute",
    right: "8px",
    top: "calc(50% - 8px)",
    cursor: "pointer",
    ...styles?.indicatorContainer, // Apply custom indicatorContainer styles if provided
  }),
  input: (provided: any) => ({
    ...provided,
    color: "black",
    ...styles?.input, // Apply custom input styles if provided
  }),
});

const DropdownIndicator = () => (
  <div style={{ display: "flex", flexDirection: "column" }}>
    <MdExpandMore style={{ transform: "rotate(180deg)" }} />
    <MdExpandMore />
  </div>
);

const Dropdown: React.FC<NotaryOwnerProps> = ({
  onChange,
  value,
  options,
  styles,
  isSearchable = false,
}) => {
  return (
    <Select
      isSearchable={isSearchable}
      value={value}
      onChange={onChange}
      options={options}
      styles={getCustomStyles(styles)}
      components={{ DropdownIndicator }}
    />
  );
};

export default Dropdown;
